import store from 'store';
import translation from 'translation';

const WILDBERRIES_ID = () => store.getters['channels/getChannelByName']('wildberries').id;

const mapAreasKeyValue = {
  bid_fixed_value: {
    search: {
      item: {key: 'bid_search', value: 0},
      value: true
    },
    recommendations: {
      item: {key: 'bid_recommendations', value: 0},
      value: false
    }
  },
  set_bid: {
    search: {
      item: {key: 'bid_search', value: 0},
      value: true
    },
    recommendations: {
      item: {key: 'bid_recommendations', value: 0},
      value: false
    }
  },
  decrease_bid: {
    search: {
      item: {key: 'min_bid_search', value: 0},
      value: true
    },
    recommendations: {
      item: {key: 'min_bid_recommendations', value: 0},
      value: false
    }
  },
  increase_bid: {
    search: {
      item: {key: 'max_bid_search', value: 0},
      value: true
    },
    recommendations: {
      item: {key: 'max_bid_recommendations', value: 0},
      value: false
    }
  },
  bid_position_for_search_cluster: {
    search: {
      item: {key: 'max_bid_search', value: 0},
      value: true
    }
  },
  set_min_bid: {
    search: {
      value: true
    },
    recommendations: {
      value: false
    }
  }
};

// Список всех ключей значений
const MAP_AREAS_KEY_VALUE = (() => {
  const set = new Set();

  Object.values(mapAreasKeyValue).
    forEach(zones => Object.values(zones || {}).
      forEach(zone => {
        const key = zone?.item?.key;
        if (key) {
          set.add(key);
        }
      }));

  return Array.from(set);
})();

export function getZoneKeyByNameAndAction (zoneName, actionType) {
  return mapAreasKeyValue?.[actionType]?.[zoneName]?.item?.key || null;
}

export function deleteDefaultsForZones (defaults, action, excludeKeys) {
  MAP_AREAS_KEY_VALUE.
    forEach((key) => {
      if (!excludeKeys.includes(key)) {
        delete defaults[key];
        delete action[key];
      }
    });
}

export function setDefaultsForZonesAndDeleteOthers (defaults, action, type) {
  const keyValueList = [];
  const zonePlacements = {};

  Object.entries(mapAreasKeyValue[type]).
    forEach(([areaKey, areaData]) => {
      zonePlacements[areaKey] = areaData.value;

      if (areaData.item) {
        keyValueList.push(areaData.item);
      }
    });

  keyValueList.forEach((item) => {
    defaults[item.key] = item.value;
  });
  defaults.zone_placements = zonePlacements;

  deleteDefaultsForZones(defaults, action, keyValueList.map(item => item.key));
}

export function isNeedToSetZonesWb ({placementType, channelId, isManualStrategy = false}) {
  return placementType !== 'WILDBERRIES_AUTO' &&
    placementType !== 'WILDBERRIES_UNIFIED' &&
    channelId === WILDBERRIES_ID() &&
    isManualStrategy;
}

export function validationRulesErrors (rules) {
  rules.forEach(rule => {
    if (rule.action.type === 'pause_placement') {
      return;
    }

    const bidSearch = rule.action[getZoneKeyByNameAndAction('search', rule.action.type)];
    const bidRecommendations = rule.action[getZoneKeyByNameAndAction('recommendations', rule.action.type)];
    const {zone_placements} = rule.action;

    const isAllCheckboxesUnchecked = Object.values(zone_placements).every(value => !value);

    if (isAllCheckboxesUnchecked) {
      throw new Error(translation.trc('newBidmanager', 'Please select at least one display area and specify the bid'), {cause: rule.uid});
    }

    const isSearchError = zone_placements.search && bidSearch === 0;
    const isRecommendationsError = zone_placements.recommendations && bidRecommendations === 0;
    if (isSearchError || isRecommendationsError) {
      throw new Error(translation.trc('newBidmanager', 'Please specify the bid for the selected display areas'), {cause: rule.uid});
    }
  });
}
